import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringSearchbarComponent } from './string-searchbar.component';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';


@NgModule({
  declarations: [
    StringSearchbarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AngularSvgIconModule,

  ],
  exports: [
    StringSearchbarComponent,
  ]
})
export class StringSearchbarModule { }
